import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import { List, ListDivider, ListHeading } from '../list';
import { cs } from '../utils';
import { useSelectContext } from './context';
/** Displays a list of options with optional heading to describe an individual group. */
export const SelectGroup = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Select', useSelectContext());
    return _jsx(List, { className: cs('vui-selectGroup', className), ref: ref, size: "sm", ...styles.group, ...rest });
});
SelectGroup.Divider = ListDivider;
SelectGroup.Heading = ListHeading;
SelectGroup.displayName = 'SelectGroup';
export default SelectGroup;
